"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._slugifyc = exports.slugifyp = exports.slugify = void 0;

var _slugify2 = _interopRequireDefault(require("slugify"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
replacement   -> replace spaces with replacement
symbols       -> replace unicode symbols or not
remove        -> (optional) regex to remove characters
lower         -> result in lower case
charmap       -> replace special characters
multicharmap  -> replace multi-characters
*/
var slugify = function slugify(value) {
  if (!value) {
    return value;
  }

  value = value.replace(/\//g, ' ').replace(/\+/g, ' ');
  return (0, _slugify2["default"])(value, {
    replacement: '-',
    remove: null,
    lower: true
  });
};

exports.slugify = slugify;

var slugifyp = function slugifyp(value) {
  if (!value) {
    return value;
  }

  value = value.replace(/\//g, ' ').replace(/\+/g, ' ');
  return (0, _slugify2["default"])(value, {
    replacement: '+',
    remove: null,
    lower: true
  });
};

exports.slugifyp = slugifyp;

var _slugifyc = function _slugifyc(value) {
  var sReplace = function sReplace(v) {
    return v.replace(/ /g, '-').replace(/\//g, '+').replace(/'/g, '+').replace(/[àáâãäå]/gi, 'a').replace(/[èéêë]/gi, 'e').replace(/[òóôõö]/gi, 'o').replace(/[ìíîï]/gi, 'i').replace(/[ùúûü]/gi, 'u').replace(/’/g, '').trim();
  };

  var sSpecialChr = function sSpecialChr(v) {
    return v.replace(/a%c2%b9/gi, 'u').replace(/%E2%80%99/gi, '').replace(/%2B/gi, '+').replace(/%F9/gi, 'u').replace(/\//g, '').replace(/\\/g, '');
  };

  var sMultiSpace = function sMultiSpace(v) {
    while (v.indexOf('  ') > -1) {
      v = v.replace(/  /g, ' ');
    }

    v = v.replace(/  /g, ' ');
    return v;
  };

  return value ? sReplace(sSpecialChr(sMultiSpace(value))) : value;
};

exports._slugifyc = _slugifyc;